export const INDUSTRY_DETAILS = [
  {
    slug: "corporate-offices",
    name: "Corporate & Offices",
    intro: "Workplaces run on infrastructure people never notice — until it fails. We keep it invisible.",
    challenges: ["Reliable connectivity for hybrid teams", "Meeting rooms that waste time instead of saving it", "Security that protects without creating friction"],
    approach: "We start with how your teams work, then engineer network, Wi-Fi, meeting-room and security systems around that flow — one design, one partner, one accountable support channel.",
    solutions: ["network-infrastructure", "wifi-wireless", "smart-office", "security-surveillance"],
  },
  {
    slug: "retail",
    name: "Retail",
    intro: "Uptime at the till, clarity on the floor, and connectivity customers expect.",
    challenges: ["POS and billing systems that cannot go down", "Loss prevention across entrances and floors", "Customer Wi-Fi and in-store experience"],
    approach: "We design surveillance, networking and power continuity as one system — so sales, security and connectivity keep working through rush hours and outages alike.",
    solutions: ["security-surveillance", "network-infrastructure", "wifi-wireless", "power-continuity"],
  },
  {
    slug: "hospitality",
    name: "Hospitality",
    intro: "Guests judge the stay, not the systems. We make sure the systems never give them a reason to.",
    challenges: ["Guest Wi-Fi expectations across every room", "Surveillance across large, multi-zone properties", "Communication between front office and operations"],
    approach: "From property-wide Wi-Fi to intercom and surveillance, we build hospitality infrastructure that staff can operate easily and guests never have to think about.",
    solutions: ["wifi-wireless", "security-surveillance", "communication", "automation"],
  },
  {
    slug: "healthcare",
    name: "Healthcare",
    intro: "Infrastructure for environments where downtime is not an inconvenience — it is a risk.",
    challenges: ["Always-on systems for critical operations", "Controlled access to sensitive zones", "Dependable communication across departments"],
    approach: "We engineer healthcare infrastructure around continuity and control: resilient networks, zoned access control, protected power and communication systems that staff can trust.",
    solutions: ["network-infrastructure", "access-control", "communication", "power-continuity"],
  },
  {
    slug: "education",
    name: "Education",
    intro: "Campuses that are connected, safe and ready for modern learning.",
    challenges: ["Campus-wide Wi-Fi for hundreds of devices", "Surveillance that keeps students safe", "Smart classrooms without daily friction"],
    approach: "We design education infrastructure for density and durability — high-capacity wireless, layered surveillance and classroom technology that teachers can simply switch on and use.",
    solutions: ["wifi-wireless", "security-surveillance", "smart-office", "it-infrastructure"],
  },
  {
    slug: "residential",
    name: "Residential Communities",
    intro: "Security and automation that residents feel as comfort, not surveillance.",
    challenges: ["Community security across gates and common areas", "Access automation for residents, staff and visitors", "Centralised monitoring without complexity"],
    approach: "We work with associations, builders and facility teams to deliver gate automation, community surveillance and communication systems designed around everyday residential life.",
    solutions: ["security-surveillance", "access-control", "automation", "communication"],
  },
  {
    slug: "commercial-buildings",
    name: "Commercial Buildings",
    intro: "Multi-tenant buildings need infrastructure that serves everyone and answers to one dashboard.",
    challenges: ["Shared infrastructure across multiple tenants", "Building-wide automation and energy control", "Central monitoring of security and systems"],
    approach: "We design backbone infrastructure, building automation and unified security for commercial properties — engineered at handover quality and supported for the long term.",
    solutions: ["automation", "network-infrastructure", "security-surveillance", "power-continuity"],
  },
  {
    slug: "smb",
    name: "Small & Medium Businesses",
    intro: "Enterprise-grade thinking, sized and priced for growing businesses.",
    challenges: ["Enterprise-grade needs on practical budgets", "No in-house IT team to manage systems", "Infrastructure that must scale with the business"],
    approach: "We give smaller organisations one accountable technology partner — right-sized infrastructure today, managed services to run it, and a design that grows when you do.",
    solutions: ["it-infrastructure", "wifi-wireless", "security-surveillance", "managed-services"],
  },
];

export const getIndustry = (slug) => INDUSTRY_DETAILS.find((i) => i.slug === slug);
